<template>
  <div class="mt-3">
    <div class="form-content-wrapper mb-0">
      <h6 class="form-title mb-3">UPLOAD BUKTI KLAIM</h6>
    </div>
    <div v-for="item in uploadRequirements" :key="item.key" class="my-3">
      <div class="upload-label-row">
        <span>{{ item.label }} <span class="text-danger">*</span></span>
        <b-button
          v-if="item.key === 'receipt'"
          size="sm"
          variant="pgiBtn"
          @click="openReceiptExample"
        >
          <i class="fa fa-download mr-1"></i>
          Form Tanda Terima
        </b-button>
      </div>
      <div class="upload-gadai-btn-wrapper mt-1">
        <b-button
          v-if="item.uploadedUrl"
          class="upload-gadai-btn"
          variant="cancelBtn"
          @click="openUploadedPreview(item)"
        >
          Lihat
        </b-button>
        <div
          v-if="item.key !== 'testimonialVideo'"
          class="cameraMobileWrapper upload-gadai-btn"
        >
          <b-button
            class="upload-gadai-btn"
            variant="cancelBtn"
            @click="onCamera(item)"
          >
            <i class="fa fa-camera mr-1"></i>
            Kamera
          </b-button>
        </div>
        <div class="browse-foto upload-gadai-btn">
          <b-form-file
            v-model="item.file"
            :state="Boolean(item.file)"
            :accept="item.accept"
            drop-placeholder="Drop file here..."
            @input="onFileChange(item)"
          />
          <b-button
            variant="cancelBtn"
            class="upload-gadai-btn"
          >
            <i class="fa fa-upload mr-1"></i>
            Upload
          </b-button>
        </div>
      </div>
    </div>

    <input
      ref="cameraInput"
      type="file"
      accept="image/*"
      capture="environment"
      style="display: none"
      @change="handleCameraMobile"
    />

    <b-modal
      id="modal-preview-upload-klaim-hadiah"
      size="xl"
      :title="activeUploadPreview.label || 'Preview Upload'"
    >
      <div class="upload-preview-wrapper">
        <iframe
          v-if="activeUploadPreview.type === 'pdf'"
          :src="activeUploadPreview.url"
          class="preview-pdf"
          title="Preview PDF"
        />
        <video
          v-else-if="activeUploadPreview.type === 'video'"
          :src="activeUploadPreview.url"
          class="preview-media"
          controls
        />
        <img
          v-else-if="activeUploadPreview.url"
          :src="activeUploadPreview.url"
          class="preview-media"
          alt="Preview Upload"
        />
      </div>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">Tutup</b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-example-receipt-klaim-hadiah"
      size="xl"
      title="Form Tanda Terima"
      hide-footer
    >
      <iframe
        :src="receiptExampleUrl"
        class="receipt-example-frame"
        title="Form Tanda Terima"
      />
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'klaim-hadiah-spektakuler-upload',
  props: {
    hadiahCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      receiptExampleUrl: 'https://pugindo-pgi.s3.ap-southeast-3.amazonaws.com/_ASSETS/tanda-terima-hadiah-gs-gadai-spektakuler.pdf',
      maxVideoSize: 50 * 1024 * 1024,
      activeCameraItem: null,
      activeUploadPreview: {
        label: '',
        type: '',
        url: '',
      },
      uploadRequirements: [
        { key: 'photo', part: 'PHOTO', label: 'Foto Nasabah dengan Hadiah dan Identitas', accept: 'image/*', file: null, previousFile: null, previewUrl: null, uploadedUrl: null },
        { key: 'receipt', part: 'RECEIPT', label: 'Tanda Terima Penyerahan Hadiah', accept: 'image/*,.pdf,application/pdf', file: null, previousFile: null, previewUrl: null, uploadedUrl: null },
        { key: 'testimonialVideo', part: 'VIDEO', label: 'Video Testimoni', accept: 'video/*', file: null, previousFile: null, previewUrl: null, uploadedUrl: null },
      ],
    }
  },
  methods: {
    async onFileChange(item) {
      if (item.file && !this.isValidUploadFile(item, item.file)) {
        const invalidFile = item.file
        this.revokePreviewUrl(item)
        item.file = null
        item.uploadedUrl = null
        this.$helper.toastErr(this, this.uploadValidationMessage(item, invalidFile))
        return
      }

      let selectedFile = item.file

      if (!selectedFile && item.uploadedUrl) {
        item.file = item.previousFile
        return
      }

      if (!selectedFile) return

      try {
        selectedFile = await this.addImageStamp(selectedFile)
        item.file = selectedFile
      } catch (error) {
        console.log(error)
        item.file = item.previousFile
        this.$helper.toastErr(this, 'Gagal memproses foto. Silakan coba lagi.')
        return
      }

      this.revokePreviewUrl(item)
      item.uploadedUrl = null

      this.$store.dispatch('loading/show', { progress: 0 })
      let response = { success: false }
      try {
        response = await this.uploadPresignedFile(item)
      } finally {
        this.$store.dispatch('loading/hide')
      }

      if (!response.success) {
        this.revokePreviewUrl(item)
        item.file = null
        item.uploadedUrl = null
        this.$helper.toastErr(this, `Gagal upload ${item.label}. Silakan coba lagi.`)
        return
      }

      item.previewUrl = URL.createObjectURL(selectedFile)
      item.uploadedUrl = response.publicUrl
      item.previousFile = selectedFile
    },
    onCamera(item) {
      this.activeCameraItem = item
      this.$nextTick(() => {
        this.$refs.cameraInput.value = ''
        this.$refs.cameraInput.click()
      })
    },
    async handleCameraMobile(event) {
      const item = this.activeCameraItem
      const file = event.target.files[0]
      this.activeCameraItem = null
      if (!file || !item) return

      try {
        item.file = file
        await this.onFileChange(item)
      } catch (error) {
        console.log(error)
        item.file = item.previousFile
        this.$helper.toastErr(this, 'Gagal memproses foto kamera. Silakan coba lagi.')
      }
    },
    async addImageStamp(file) {
      if (!file.type || !file.type.startsWith('image/')) return file

      const [position, image] = await Promise.all([
        this.getCurrentPosition(),
        this.loadImageFile(file),
      ])
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = image.width
      canvas.height = image.height

      ctx.drawImage(image, 0, 0)
      this.drawImageStamp(ctx, canvas, position)

      const blob = await new Promise(resolve => {
        canvas.toBlob(resolve, 'image/jpeg', 0.9)
      })

      if (!blob) return file

      return new File([blob], this.replaceFileExtension(file.name, 'jpg'), {
        type: 'image/jpeg',
        lastModified: Date.now(),
      })
    },
    loadImageFile(file) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        const url = URL.createObjectURL(file)

        image.onload = () => {
          URL.revokeObjectURL(url)
          resolve(image)
        }
        image.onerror = error => {
          URL.revokeObjectURL(url)
          reject(error)
        }
        image.src = url
      })
    },
    getCurrentPosition() {
      return new Promise(resolve => {
        if (!navigator.geolocation) {
          resolve({ latitude: '-', longitude: '-' })
          return
        }

        navigator.geolocation.getCurrentPosition(
          position => {
            resolve({
              latitude: position.coords.latitude.toFixed(6),
              longitude: position.coords.longitude.toFixed(6),
            })
          },
          () => resolve({ latitude: '-', longitude: '-' }),
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 },
        )
      })
    },
    drawImageStamp(ctx, canvas, position) {
      const date = this.$helper.formatTanggalDMY()
      const time = this.$helper.waktu24()
      const padding = Math.max(10, Math.round(canvas.width * 0.018))
      const fontSize = Math.max(18, Math.round(canvas.width * 0.032))
      const lineHeight = Math.round(fontSize * 1.45)
      const firstLineY = canvas.height - padding - lineHeight
      const secondLineY = canvas.height - padding

      ctx.font = `${fontSize}px Arial`
      ctx.lineWidth = Math.max(3, Math.round(fontSize * 0.16))
      ctx.strokeStyle = '#000000'
      ctx.fillStyle = '#ffffff'
      ctx.strokeText(`${date} ${time}`, padding, firstLineY)
      ctx.fillText(`${date} ${time}`, padding, firstLineY)
      ctx.strokeText(`${position.latitude} ${position.longitude}`, padding, secondLineY)
      ctx.fillText(`${position.latitude} ${position.longitude}`, padding, secondLineY)
    },
    replaceFileExtension(fileName, extension) {
      const name = fileName || `hadiah-${Date.now()}`
      if (!name.includes('.')) return `${name}.${extension}`
      return name.replace(/\.[^.]+$/, `.${extension}`)
    },
    openUploadedPreview(item) {
      this.activeUploadPreview = {
        label: item.label,
        type: this.uploadPreviewType(item.file),
        url: item.previewUrl,
      }
      this.$bvModal.show('modal-preview-upload-klaim-hadiah')
    },
    openReceiptExample() {
      this.$bvModal.show('modal-example-receipt-klaim-hadiah')
    },
    uploadPreviewType(file) {
      if (!file || !file.type) return 'image'
      if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) return 'pdf'
      if (file.type.startsWith('video/')) return 'video'
      return 'image'
    },
    isValidUploadFile(item, file) {
      const type = file.type || ''
      const name = (file.name || '').toLowerCase()

      if (item.key === 'testimonialVideo') {
        return type.startsWith('video/') && file.size <= this.maxVideoSize
      }
      if (item.key === 'photo') {
        return type.startsWith('image/')
      }

      return type.startsWith('image/') ||
        type === 'application/pdf' ||
        name.endsWith('.pdf')
    },
    uploadValidationMessage(item, file) {
      if (item.key === 'testimonialVideo') {
        if (file && file.size > this.maxVideoSize) {
          return 'Video Testimoni maksimal 50MB.'
        }
        return 'Video Testimoni hanya menerima file video.'
      }
      if (item.key === 'photo') return 'Foto Nasabah dengan Hadiah dan Identitas hanya menerima foto.'
      return 'Tanda Terima Penyerahan Hadiah hanya menerima foto atau PDF.'
    },
    uploadPresignedFile(item) {
      return this.$helper.uploadPresigned({
        vue: this,
        path: 'voucher/spin/presigned-url',
        params: {
          code: this.hadiahCode,
          part: item.part,
          fileExtension: this.getFileExtension(item.file),
        },
        fileUpload: item.file,
        contentType: this.getUploadContentType(item.file),
        onUploadProgress: progress => this.setUploadProgress(progress),
        useXhr: true,
      })
    },
    setUploadProgress(progress) {
      this.$store.dispatch('loading/setProgress', Math.min(progress, 100))
    },
    getUploadContentType(file) {
      return (file && file.type) || 'image'
    },
    getFileExtension(file) {
      const name = (file && file.name) || ''
      const extension = name.split('.').pop()
      if (extension && extension !== name) return extension.toLowerCase()

      const type = (file && file.type) || ''
      return type.split('/').pop() || ''
    },
    validateUploads() {
      const missingUpload = this.uploadRequirements.find(item => !item.uploadedUrl)
      if (missingUpload) {
        this.$helper.toastErr(this, `${missingUpload.label} wajib diunggah.`)
        return false
      }

      return true
    },
    getUploadedUrl(key) {
      const item = this.uploadRequirements.find(upload => upload.key === key)
      return item ? item.uploadedUrl : null
    },
    revokePreviewUrl(item) {
      if (item.previewUrl) {
        URL.revokeObjectURL(item.previewUrl)
        item.previewUrl = null
      }
    },
    resetUploads() {
      this.uploadRequirements.forEach(item => {
        this.revokePreviewUrl(item)
        item.file = null
        item.previousFile = null
        item.uploadedUrl = null
      })
    },
  },
  beforeDestroy() {
    this.resetUploads()
  },
}
</script>

<style scoped>
.upload-label-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.browse-foto {
  position: relative;
  width: 150px;
}

.browse-foto .custom-file {
  opacity: 0;
  z-index: 1;
}

.browse-foto .custom-file .custom-file-input {
  z-index: 0;
}

.browse-foto button {
  position: absolute;
  top: 0;
  left: 0;
}

.upload-gadai-btn-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.upload-gadai-btn {
  width: 150px;
}

.upload-preview-wrapper {
  display: flex;
  justify-content: center;
}

.preview-media {
  max-width: 100%;
  max-height: 75vh;
}

.preview-pdf {
  width: 100%;
  min-height: 75vh;
  border: 0;
}

.receipt-example-frame {
  border: 0;
  min-height: 75vh;
  width: 100%;
}

@media (max-width: 576px) {
  .upload-label-row {
    gap: 8px;
  }

  .upload-label-row .btn {
    margin-bottom: 8px;
    width: auto;
  }

  .upload-gadai-btn,
  .browse-foto {
    width: 100%;
  }
}
</style>
